export interface IAdditionalNotes {
  text: string
  type: AdditionalNotesTypesEnum
}

export enum AdditionalNotesTypesEnum {
  Error,
  Warning,
  Note,
}
